import Fluxible from 'fluxible';

const app = new Fluxible();
app.getContext = function () {
    if (!this.context) {
        this.context = app.createContext();
    }

    return this.context;
};

export default app;



// WEBPACK FOOTER //
// ./src/web/js/contest/data/app.js